var SymbolEntity = {
    symbol: null,
    setSymbol: function (value) {
        this.symbol = value;
    },
};
export default SymbolEntity;
